var SETUP_FIELDS_KEYS = {
  // GL_ACCOUNT_FIELDS
  DEPARTMENT: 'DEPARTMENT',
  // Same as the name or Key in the API
  ACCOUNT_SUBTYPE: 'ACCOUNT_SUBTYPE',
  ACCOUNT_TYPE: 'ACCOUNT_TYPE',
  FINANCIAL_STATEMENT_GROUP: 'FINANCIAL_STATEMENT_GROUP',
  FINANCIAL_STATEMENT_SUB_GROUP: 'FINANCIAL_STATEMENT_SUB_GROUP',
  UNIT_ANALYSIS_GROUP: 'UNIT_ANALYSIS_GROUP',
  // JOURNAL_SETUP_FIELDS
  JOURNAL_TYPE: 'JOURNAL_TYPE',
  DOCUMENT_TYPE: 'DOCUMENT_TYPE',
  // Transaction Posting Fields
  TRANSACTION_DOCUMENT_TYPE: 'TRANSACTION_DOCUMENT_TYPE',
  TRANSACTION_REFERENCE_TYPE: 'TRANSACTION_REFERENCE_TYPE',
  TRANSACTION_TYPE: 'TRANSACTION_TYPE',
  REFERENCE_TYPE: 'REFERENCE_TYPE',
  ACCOUNTS: 'ACCOUNTS',
  JOURNALS: 'JOURNALS' // Approval Hierarchy
  // APPROVAL_TYPES: 'APPROVAL_TYPES',
  // ITEM_TYPES: 'ITEM_TYPES',
  // APPROVERS: 'APPROVERS',

};
export default SETUP_FIELDS_KEYS;